import { restrictionMeasureIdFormat } from "@redotech/redo-xborder-outbound-id";
import * as z from "zod";
import { null as zNull } from "zod";
import { restrictionTier } from "./restriction-tier-output";

export const accountRestrictionMeasureOutput = z.object({
  measureId: restrictionMeasureIdFormat.schema,
  destinationCountryCode: z.string(),
  category: z.string().nullable(),
  summary: z.string(),
  tier: restrictionTier,
  sourceUrl: z.string().nullable(),
  affectedProductCount: z.number(),
  lastSeenAt: z.date(),
  isResolved: z.boolean(),
  resolutionNote: z.string().nullable(),
  resolvedAt: z.date().nullable(),
});

export const listAccountRestrictionMeasures = {
  name: "listAccountRestrictionMeasures" as const,
  input: zNull(),
  output: z.object({ measures: z.array(accountRestrictionMeasureOutput) }),
};
